import { useState } from 'react';

import RestoreIcon from '@/assets/svg/ui-elements/sync-square-orange.svg';
import { useGlobalModal } from '@/global-hooks/use-global-modal';
import { Button, Modal, theme } from '@/shared/design-system';

import {
  ActionInfoCard,
  ActionModalActions,
  ActionModalBody,
  ActionModalSeparator,
} from './action-modal-shared';

export type RestoreActionModalProps = {
  type: 'fund' | 'entity';
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
};

const YELLOW_STYLE = {
  background: theme.colors.warning.solid,
  borderColor: theme.colors.warning.solid,
  color: theme.colors.black[100],
};

export const RestoreActionModal = () => {
  const { open, handleClose, props } = useGlobalModal('RESTORE_ACTION_MODAL');
  const [isPending, setIsPending] = useState(false);
  const isFund = props?.type === 'fund';
  const subject = isFund ? 'Fund' : 'Entity';

  const handleConfirm = async () => {
    setIsPending(true);
    try {
      await props?.onConfirm();
    } finally {
      setIsPending(false);
    }
  };

  const isLoading = isPending || props?.isLoading;

  return (
    <Modal
      open={open}
      onOpenChange={(o) => (!o ? handleClose() : undefined)}
      title={`Restore ${subject}`}
      showClose
    >
      <ActionModalBody>
        <ActionModalSeparator />
        <ActionInfoCard
          icon={<RestoreIcon width={24} height={24} />}
          title={`Are you sure you want to Restore this rejected ${subject}?`}
          description={`This will return the ${subject} to pending/awaiting approval status and require manual review and approval.`}
        />
        <ActionModalSeparator />
        <ActionModalActions>
          <Button
            color="primary"
            variant="solid"
            size="lg"
            disabled={isLoading}
            onClick={handleConfirm}
            style={YELLOW_STYLE}
          >
            Restore
          </Button>
          <Button color="tertiary" variant="outline" size="lg" onClick={handleClose}>
            Go Back
          </Button>
        </ActionModalActions>
      </ActionModalBody>
    </Modal>
  );
};
